import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Welcome from './views/Welcome.vue'
import LinkDevice from './views/LinkDevice.vue'
import Recover from './views/Recover.vue'
import JoinRemote from './views/JoinRemote.vue'
import Connect from './views/Connect.vue'
import { hasServer } from './platform'

// Pages usable without a session on this device (App.vue shows the landing page elsewhere).
export const PUBLIC_ROUTES = ['connect', 'invite', 'link', 'recover', 'join']

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/connect', name: 'connect', component: Connect },
    { path: '/i/:code', name: 'invite', component: Welcome },
    { path: '/link/:token', name: 'link', component: LinkDevice },
    { path: '/recover', name: 'recover', component: Recover },
    { path: '/join', name: 'join', component: JoinRemote },
    { path: '/', name: 'home', component: Home },
    // Space QR codes encode an upper-case link with a short code (smaller QR): /S/<CODE>.
    // Home resolves it against my spaces.
    { path: '/S/:code', name: 'spaceCode', component: Home, sensitive: true },
    { path: '/s/:spaceId/:convId?', name: 'space', component: Home },
    { path: '/dm/:convId?', name: 'dm', component: Home },
    { path: '/library', name: 'library', component: Home },
    { path: '/server', name: 'server', component: Home },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

// The apps start by asking which server (the browser is always on its own).
router.beforeEach((to) => (hasServer() || to.name === 'connect' ? true : { name: 'connect' }))
